"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/BIFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_26)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_26`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M9.15088 11.979L-6 22.0772V1.88071L9.15088 11.979ZM30 1.88071V22.0772L14.8491 11.979L30 1.88071Z",
					fill: "#47A644"
				}),
				/* @__PURE__ */ n("path", {
					d: "M30 1.8807L14.7789 11.9789L30 22.0772V24H27.1158L11.9649 13.8526L-3.18597 24H-6V22.0772L9.15088 11.9789L-6 1.8807V0H-3.18597L11.9649 10.0982L27.1158 0H30V1.8807Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M30 1.8807L14.8491 11.9789L30 22.0772V24H27.193L11.9649 13.8526L-3.26316 24H-6V22.0772L9.15088 11.9789L-6 1.8807V0H-3.18597L11.9649 10.0982L27.1158 0H30V1.8807Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.6562 19.0105C15.5396 19.0105 18.6877 15.8624 18.6877 11.9789C18.6877 8.0955 15.5396 4.94736 11.6562 4.94736C7.77272 4.94736 4.62457 8.0955 4.62457 11.9789C4.62457 15.8624 7.77272 19.0105 11.6562 19.0105Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.6421 7.27017L12.1614 8.17544H13.2L12.6807 9.07368L13.2 9.97193H12.1614L11.6421 10.8772L11.1228 9.97193H10.0842L10.6035 9.07368L10.0842 8.17544H11.1228L11.6421 7.27017ZM14.3649 11.9509L14.8842 12.8561H15.9228L15.4035 13.7544L15.9228 14.6526H14.8842L14.3649 15.5579L13.8456 14.6526H12.8L13.3193 13.7544L12.8 12.8561H13.8456L14.3649 11.9509ZM8.94736 11.9509L9.46666 12.8561H10.5123L9.99297 13.7544L10.5123 14.6526H9.46666L8.94736 15.5579L8.42806 14.6526H7.38947L7.90876 13.7544L7.38947 12.8561H8.42806L8.94736 11.9509Z",
					fill: "#D80027",
					stroke: "#47A644",
					strokeWidth: .210526
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_26`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as BIFlag };
